import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const HeadingDesktopStyles = styled.div`
  margin-bottom: 40px;

  .stock-indicator {
    position: relative;
    position: relative;
    top: -20px;
  }
  .home-info {
    padding-top: 15px;

    .see-below span {
      font-family: 'source-sans-pro', sans-serif;
      font-size: 12px;
      color: ${Colors.accent.grey1.standard};
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .name-action-buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 36px;

    .name-favoriting {
      display: flex;

      h2 {
        border: solid 1px transparent;
      }
      .favoriting-heart-container {
        margin-left: -30px;
        padding-right: 16px;
        padding-top: 17px;
      }
    }
    .desktop-action-buttons {
      border-left: solid 1px ${Colors.accent.grey4.standard};
      padding-left: 30px;

      button {
        min-width: 200px;

        &:last-child {
          padding-top: 13px;
          padding-bottom: 13px;
        }
      }
    }
  }
  .home-specs-container {
    display: flex;

    .price-heading,
    .price-heading-loading {
      padding-top: 3px;
      min-width: 180px;
    }
    .price-heading-loading {
      background-color: ${Colors.accent.grey3.standard};
      height: 18px;
      margin-right: 20px;
      margin-top: 5px;
      opacity: 0.3;
    }
    .divider {
      color: ${Colors.accent.grey3.standard};
      margin: 0 25px;
    }
  }
`;
